import BaseModule from "./base-module";

class Store extends BaseModule {
  getStoreInfo(params) {
    return this.get("/customer/v1/store", { params });
  }
  getDeclaration(params) {
    return this.get("/qrcode/v1/copywriting/setting", { params });
  }

  getBuffetRound(params) {
    return this.get("/qrcode/v1/buffetconf/edit", { params });
  }

  getStorePayment(params) {
    return this.get("/customer/v1/store/paymethod", { params });
  }

  // 下单
  createOrder(payload) {
    return this.post(`/qrcode/v1/store/order`, payload);
  }

  // 计算订单价格
  calculateOrder(params) {
    return this.post("/qrcode/v1/calculate", params);
  }

  // 获取是否允许扫码下单的状态
  getScanStatus(params) {
    return this.get("/customer/v1/store/scanStatus", params);
  }

  // 获取区域
  getTableArea(params) {
    return this.get("/store/v1/tables/area", params);
  }

  // 获取桌位
  getTableList(params) {
    return this.get("/store/v1/tables", { params });
  }
}

export default new Store();
